module.exports = __webpack_public_path__ + "static/img/24.02323fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhwhyx/24.jpg
// module id = N6Ao
// module chunks = 1